import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import IntlMessages from 'util/IntlMessages';
import CustomScrollbars from 'util/CustomScrollbars';
import { Button } from '@material-ui/core';
import { requestGql } from 'constants/Request';

class SidenavContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    componentDidMount() {
        
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
    }

    render() {
        
        return (
            <div></div>
            
        );
    }
}

export default withRouter(SidenavContent);
